export default __webpack_public_path__ + "b778aaeb5fb86bea83d19bac1a1f0869.jpg";